import { Box, CardMedia, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import cs from 'classnames';
import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';
import { hasOneOfPermissions } from '../../../../../shared/auth/permissionHelper';
import { usePermissions } from '../../../../Session';
import useMenuItems, { MenuItem } from '../useMenuItems';
import { SidePanelMenuProps } from './DrawerHeader';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            marginTop: '50px',
        },
        itemWrapper: {
            display: 'flex',
            color: theme.palette.primary.contrastText,
            marginBottom: '16px',
            paddingLeft: '40px',
            height: '56px',
            '&:hover': {
                background: theme.palette.secondary.main,
            },
        },
        selected: {
            background: theme.palette.secondary.main,
        },
        item: {
            display: 'flex',
            maxWidth: '256px',
        },
        iconContainer: {
            minWidth: '24px',
            height: '24px',
            margin: 'auto',
            marginRight: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        },
        icon: {
            width: '24px',
            height: '24px',
        },
    })
);

const SidePanelMenu = ({ open }: SidePanelMenuProps) => {
    const location = useLocation();
    const history = useHistory();
    const permissions = usePermissions();
    const styles = useStyles();
    const redirect = useCallback((path: string) => () => history.push(path), [history]);

    const isActivePath = useCallback(
        (path: string) => location.pathname.toLowerCase() === path.toLowerCase(),
        [location.pathname]
    );

    const canDisplayMenuItem = useCallback(
        (item: MenuItem) =>
            item.displayForBiometricSetting || hasOneOfPermissions(permissions, item.allowedPermissions || []),
        [permissions]
    );

    const menuItems = useMenuItems();

    return (
        <List className={styles.root}>
            {menuItems.filter(canDisplayMenuItem).map(menu => {
                const classes = isActivePath(menu.to) ? cs(styles.itemWrapper, styles.selected) : styles.itemWrapper;

                return (
                    <ListItem key={menu.text} className={classes} onClick={redirect(menu.to)} button>
                        <Box className={styles.item}>
                            <ListItemIcon className={styles.iconContainer}>
                                <CardMedia className={styles.icon} image={menu.icon} />
                            </ListItemIcon>
                            {open && <ListItemText primary={menu.text} />}
                        </Box>
                    </ListItem>
                );
            })}
        </List>
    );
};

export default SidePanelMenu;
